import React from 'react';
import autoBind from 'react-autobind';
import Slider from 'material-ui/Slider';
import HelpToolTip from '../../components/HelpToolTip';

const style = {
  wrapper: {
    marginTop: 14
  },
  label: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.3)'
  },
  slider: {
    marginBottom: 0
  }
};

class FieldSlider extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange(event, newValue) {
    this.props.onChange({ name: this.props.name, value: newValue });
  }

  render() {
    const _props = { ...this.props };
    _props.onChange = this.handleChange;
    return (
      <div style={style.wrapper}>
        <div style={{ position: 'relative' }}>
          {this.props.tooltip && (
            <HelpToolTip
              style={{ position: 'absolute' }}
              tip={this.props.tooltip}
            />
          )}
          <label
            style={{
              ...style.label,
              paddingLeft: this.props.tooltip ? 20 : 12
            }}
          >
            {_props.label}
          </label>
          <Slider {..._props} sliderStyle={style.slider} />
        </div>
      </div>
    );
  }
}

export default FieldSlider;



// WEBPACK FOOTER //
// ./src/components/FieldSlider/index.jsx